<template>
    <div class="row">
        <div class="col-lg-12">
            <div class="nav-wizards-container">
                <nav class="nav nav-wizards-2 mb-3">
                    <div class="nav-item col">
                        <a class="nav-link "
                            v-bind:class="{ 'completed': completado1 && !tab1,'active': tab1 }"
                             @click="$emit('evento', 'paso1')"  href="#">
                            <div class="nav-text">1. Registre Datos</div>
                        </a>
                    </div>
                    <div class="nav-item col">
                        <a class="nav-link "
                            v-bind:class="{ 'completed': completado1 && completado2 && !tab2,'active': tab2 ,'disabled': !completado1 ,'process':completado1 && !tab2}"
                            @click="$emit('evento', 'paso2')" href="#">
                            <div class="nav-text">2. Cargue las Fotos</div>
                        </a>
                    </div>
                    <div class="nav-item col">
                        <a class="nav-link "
                            v-bind:class="{ 'completed': completado1 && completado2 && completado3 && !tab3,'active': tab3,'disabled': !completado1|| !completado2,'process':completado1 && completado2 && !tab3 }"
                             @click="$emit('evento', 'paso3')" href="#">
                            <div class="nav-text">3. Cargue los PDFs</div>
                        </a>
                    </div>
                </nav>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "TabWizardComponent",
        props:["tab1","tab2","tab3","completado1","completado2","completado3"]

    }
</script>
<style scoped>
    .nav-link .nav-text {
        text-align: center;
        font-weight: 600;
        font-size: .75rem;
        position: relative;
        z-index: 10;
        background: inherit;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .nav-link.completed {
        /*  background: #5bacf8;*/
        color: #fff;
    }

    .nav-item .nav-link.completed {
        /*background: #5bacf8;*/
        /*background: #348fe2;*/
        color: #fff;
    }

    .nav.nav-wizards-2 .nav-item .nav-link {
        position: relative;
        border-radius: 60px;
    }

    .nav-link .nav-text {
        text-align: center;
        font-weight: 600;
        font-size: .75rem;
        position: relative;
        z-index: 10;
        background: inherit;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .nav-link.active {
        box-shadow: 0 0 0 4px #348fe233;
    }


    .nav.nav-wizards-2 .nav-item .nav-link.completed {
        /*  background: #348fe2;*/
        /*background: #5bacf8;*/
        background: #b990ff;
        color: #fff;
    }

    .active {
        background: #8753de;
        color: #fff;
    }

    .process {
        background: #f3f6f8;
        color: #000;
        box-shadow: 0 0 0 4px #a4c9ec63;
    }

    .nav.nav-wizards-2 .nav-item .nav-link.disabled {
        color: rgba(var(--app-component-color-rgb), .25);
        background-color: #e9ecef;
    }
</style>